/**
 * @author Ariel
 * @date 2020-08-12
 * @description 班级信息弹出
 */
import React from "react";
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: '班级名称',
      name: 'name',
      dataIndex: 'name',
      searchItem: {},
      tableItem: {
        width: 120
      }
    },
    {
      title: '班级时间',
      name: 'classDate',
      dataIndex: 'classDate',
      tableItem: {
        width: 200,
        render: (text, record) => {
          const {startDate, endDate} = record;
          let classDate = formatterDate(startDate) + " ~ " + formatterDate(endDate);
          return classDate
        }
      }
    },
    {
      title: '班级开始时间',
      name: 'classDate',
      dataIndex: 'classDate',
      searchItem: {
        type: 'date~',
        showTime: {format: 'HH:mm'},
        format: 'YYYY-MM-DD HH:mm'
      },
    },
    {
      title: '课程名称',
      name: 'programName',
      dataIndex: 'programName',
      tableItem: {
        width: 200,
      },
      searchItem: {}
    },
    {
      title: '课程编号',
      name: 'programCode',
      dataIndex: 'programCode',
      tableItem: {
        width: 220,
      },
      searchItem: {}
    },
    {
      title: '限制人数',
      name: 'limitNum',
      dataIndex: 'limitNum',
      tableItem: {
        width: 100,
      }
    },
  ]
}
const tableApi = (api = {}) => {
  return {
    path: 'classManagement/listByCondPage',
    ...api
  }

}
const classInfo = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(self),
    cols: {
      xs: 24,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default classInfo
